export const dataByStates = [
  {
    label: 'Alabama',
    value: 'AL',
    institution: 'Auburn University',
    numberOfVets: '1,150',
    annualSalary: '$105,660',
    popularBreed: 'Dachshund',
  },
  {
    label: 'Alaska',
    value: 'AK',
    institution: 'Alaska Pacific University (APU)',
    numberOfVets: '220',
    annualSalary: '$109,100',
    popularBreed: 'Akita',
  },
  {
    label: 'American Samoa',
    value: 'AS',
  },
  {
    label: 'Arizona',
    value: 'AZ',
    institution: 'University of Arizona',
    numberOfVets: '1,480',
    annualSalary: '$114,460',
    popularBreed: 'Pug',
  },
  {
    label: 'Arkansas',
    value: 'AR',
    institution: 'University of Arkansas, Fayetteville',
    numberOfVets: '480',
    annualSalary: '$90,980',
    popularBreed: 'Poodle',
  },
  {
    label: 'California',
    value: 'CA',
    institution: 'University of California, Davis',
    numberOfVets: '7,620',
    annualSalary: '$126,690',
    popularBreed: 'Maltese',
  },
  {
    label: 'Colorado',
    value: 'CO',
    institution: 'Colorado State University, Fort Collins',
    numberOfVets: '2,320',
    annualSalary: '$98,690',
    popularBreed: 'Rhodesian Ridgeback',
  },
  {
    label: 'Connecticut',
    value: 'CT',
    institution: 'Yale University',
    numberOfVets: '920',
    annualSalary: '$134,050',
    popularBreed: 'Siberian Husky',
  },
  {
    label: 'Delaware',
    value: 'DE',
    institution: '',
    numberOfVets: '260',
    annualSalary: '$120,380',
    popularBreed: 'Cane Corso',
  },
  {
    label: 'District Of Columbia',
    value: 'DC',
    institution: 'Virginia-Maryland College of Veterinary Medicine',
    numberOfVets: '80',
    annualSalary: '$137,170',
    popularBreed: 'Bichon Frise',
  },
  {
    label: 'Federated States Of Micronesia',
    value: 'FM',
  },
  {
    label: 'Florida',
    value: 'FL',
    institution: 'University of Florida',
    numberOfVets: '4,790',
    annualSalary: '$108,320',
    popularBreed: 'French Bulldog',
  },
  {
    label: 'Georgia',
    value: 'GA',
    institution: 'University of Georgia',
    numberOfVets: '2,200',
    annualSalary: '$105,450',
    popularBreed: 'Bulldog',
  },
  {
    label: 'Guam',
    value: 'GU',
  },
  {
    label: 'Hawaii',
    value: 'HI',
    institution: 'University of Hawaii, Manoa',
    numberOfVets: '270',
    annualSalary: '$120,440',
    popularBreed: 'Shiba Inu',
  },
  {
    label: 'Idaho',
    value: 'ID',
    institution: 'University of Idaho',
    numberOfVets: '490',
    annualSalary: '$104,790',
    popularBreed: 'Border Collie',
  },
  {
    label: 'Illinois',
    value: 'IL',
    institution: 'University of Illinois at Urbana-Champaign',
    numberOfVets: '2,550',
    annualSalary: '$102,550',
    popularBreed: 'French Bulldog',
  },
  {
    label: 'Indiana',
    value: 'IN',
    institution: 'Purdue University',
    numberOfVets: '1,610',
    annualSalary: '$99,210',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Iowa',
    value: 'IA',
    institution: 'Iowa State University',
    numberOfVets: '1,170',
    annualSalary: '$95,910',
    popularBreed: 'Bichon Frise',
  },
  {
    label: 'Kansas',
    value: 'KS',
    institution: 'Kansas State University',
    numberOfVets: '820',
    annualSalary: '$93,050',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Kentucky',
    value: 'KY',
    institution: 'University of Kentucky',
    numberOfVets: '1,200',
    annualSalary: '$96,240',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Louisiana',
    value: 'LA',
    institution: 'Tulane University',
    numberOfVets: '940',
    annualSalary: '$113,910',
    popularBreed: 'St. Bernard',
  },
  {
    label: 'Maine',
    value: 'ME',
    institution: '',
    numberOfVets: '510',
    annualSalary: '$107,600',
    popularBreed: 'Labrador',
  },
  {
    label: 'Marshall Islands',
    value: 'MH',
  },
  {
    label: 'Maryland',
    value: 'MD',
    institution: 'Johns Hopkins University',
    numberOfVets: '1,740',
    annualSalary: '$124,510',
    popularBreed: 'Bullmastiff',
  },
  {
    label: 'Massachusetts',
    value: 'MA',
    institution: 'Tufts University',
    numberOfVets: '1,900',
    annualSalary: '$114,470',
    popularBreed: 'French Bulldog',
  },
  {
    label: 'Michigan',
    value: 'MI',
    institution: 'Michigan State University',
    numberOfVets: '2,280',
    annualSalary: '$109,170',
    popularBreed: 'Newfoundland',
  },
  {
    label: 'Minnesota',
    value: 'MN',
    institution: 'University of Minnesota,  Twin Cities',
    numberOfVets: '1,680',
    annualSalary: '$107,110',
    popularBreed: 'Cavalier King Charles Spaniel',
  },
  {
    label: 'Mississippi',
    value: 'MS',
    institution: 'Mississippi State University',
    numberOfVets: '560',
    annualSalary: '$101,930',
    popularBreed: 'Yorkshire Terrier',
  },
  {
    label: 'Missouri',
    value: 'MO',
    institution: 'University of Missouri,  Columbia',
    numberOfVets: '1,570',
    annualSalary: '$83,830',
    popularBreed: 'Rottweiler',
  },
  {
    label: 'Montana',
    value: 'MT',
    institution: 'Montana State University, Bozeman',
    numberOfVets: '550',
    annualSalary: '$82,070',
    popularBreed: 'Australian Shepherd',
  },
  {
    label: 'Nebraska',
    value: 'NE',
    institution: 'University of Nebraska, Lincoln',
    numberOfVets: '690',
    annualSalary: '$93,460',
    popularBreed: 'Soft-coated Wheaten Terrier',
  },
  {
    label: 'Nevada',
    value: 'NV',
    institution: 'University of Nevada, Reno',
    numberOfVets: '550',
    annualSalary: '$95,680',
    popularBreed: 'Pomeranian',
  },
  {
    label: 'New Hampshire',
    value: 'NH',
    institution: '',
    numberOfVets: '570',
    annualSalary: '$113,910',
    popularBreed: 'Golden Retriever',
  },
  {
    label: 'New Jersey',
    value: 'NJ',
    institution: 'Rutgers, The State University of New Jersey',
    numberOfVets: '1,770',
    annualSalary: '$127,360',
    popularBreed: 'Maltese',
  },
  {
    label: 'New Mexico',
    value: 'NM',
    institution: 'University of New Mexico',
    numberOfVets: '510',
    annualSalary: '$91,660',
    popularBreed: 'Chihuahua',
  },
  {
    label: 'New York',
    value: 'NY',
    institution: 'Cornell University',
    numberOfVets: '3,640',
    annualSalary: '$129,210',
    popularBreed: 'French Bulldog',
  },
  {
    label: 'North Carolina',
    value: 'NC',
    institution: 'North Carolina State University',
    numberOfVets: '2,760',
    annualSalary: '$113,160',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'North Dakota',
    value: 'ND',
    institution: 'North Dakota State University',
    numberOfVets: '280',
    annualSalary: '$98,990',
    popularBreed: 'German Shorthaired Pointer',
  },
  {
    label: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    label: 'Ohio',
    value: 'OH',
    institution: 'Ohio State University, Columbus',
    numberOfVets: '3,330',
    annualSalary: '$98,010',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Oklahoma',
    value: 'OK',
    institution: 'Oklahoma State University,  Stillwater',
    numberOfVets: '790',
    annualSalary: '$84,940',
    popularBreed: 'Rottweiler',
  },
  {
    label: 'Oregon',
    value: 'OR',
    institution: 'Oregon State University',
    numberOfVets: '1,540',
    annualSalary: '$107,150',
    popularBreed: 'Bullmastiff',
  },
  {
    label: 'Palau',
    value: 'PW',
  },
  {
    label: 'Pennsylvania',
    value: 'PA',
    institution: 'University of Pennsylvania',
    numberOfVets: '2,690',
    annualSalary: '$119,490',
    popularBreed: 'Rottweiler',
  },
  {
    label: 'Puerto Rico',
    value: 'PR',
    institution: 'University of Puerto Rico',
    numberOfVets: '140',
    annualSalary: '$68,340',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'Rhode Island',
    value: 'RI',
    institution: 'Brown University',
    numberOfVets: '250',
    annualSalary: '$129,880',
    popularBreed: 'French Bulldog',
  },
  {
    label: 'South Carolina',
    value: 'SC',
    institution: 'Clemson University',
    numberOfVets: '1,320',
    annualSalary: '$96,560',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'South Dakota',
    value: 'SD',
    institution: 'South Dakota State University',
    numberOfVets: '340',
    annualSalary: '$92,800',
    popularBreed: 'German Shorthaired Pointe',
  },
  {
    label: 'Tennessee',
    value: 'TN',
    institution: 'University of Tennessee,  Knoxville',
    numberOfVets: '1,500',
    annualSalary: '$103,480',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Texas',
    value: 'TX',
    institution: 'Texas A&M University, College Station',
    numberOfVets: '5,400',
    annualSalary: '$113,720',
    popularBreed: 'Doberman Pinscher',
  },
  {
    label: 'Utah',
    value: 'UT',
    institution: 'Utah State University',
    numberOfVets: '540',
    annualSalary: '$103,350',
    popularBreed: 'English Cocker Spaniel',
  },
  {
    label: 'Vermont',
    value: 'VT',
    institution: 'University of Vermont',
    numberOfVets: '400',
    annualSalary: '$100,730',
    popularBreed: 'Golden Retriever',
  },
  {
    label: 'Virgin Islands',
    value: 'VI',
  },
  {
    label: 'Virginia',
    value: 'VA',
    institution: 'Virginia Polytechnic Institute and State University',
    numberOfVets: '2,600',
    annualSalary: '$108,730',
    popularBreed: 'Bichon Frise',
  },
  {
    label: 'Washington',
    value: 'WA',
    institution: 'University of Washington',
    numberOfVets: '2,040',
    annualSalary: '$112,760',
    popularBreed: 'Siberian Husky',
  },
  {
    label: 'West Virginia',
    value: 'WV',
    institution: 'West Virginia University',
    numberOfVets: '300',
    annualSalary: '$126,060',
    popularBreed: 'German Shepherd',
  },
  {
    label: 'Wisconsin',
    value: 'WI',
    institution: 'University of Wisconsin,  Madison',
    numberOfVets: '1,860',
    annualSalary: '$95,870',
    popularBreed: 'Great Dane',
  },
  {
    label: 'Wyoming',
    value: 'WY',
    institution: 'University of Wyoming',
    numberOfVets: '200',
    annualSalary: '$105,440',
    popularBreed: 'Welsh Corgi',
  },

  {
    label: 'Alberta',
    value: 'AB',
    institution: 'University of Calgary',
    numberOfVets: '1,800',
    annualSalary: 'CAD 85,000 - 100,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'British Columbia',
    value: 'BC',
    institution: '',
    numberOfVets: '1,800',
    annualSalary: 'CAD 85,000 - 100,000',
    popularBreed: 'Golden Retriever',
  },
  {
    label: 'Manitoba',
    value: 'MB',
    institution: '',
    numberOfVets: '400',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'New Brunswick',
    value: 'NB',
    institution: '',
    numberOfVets: '300',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'NL',
    institution: '',
    numberOfVets: '100',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'Golden Retriever',
  },
  {
    label: 'Northwest Territories',
    value: 'NT',
  },
  {
    label: 'Nova Scotia',
    value: 'NS',
    institution: '',
    numberOfVets: '400',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'Nunavut',
    value: 'NU',
  },
  {
    label: 'Ontario',
    value: 'ON',
    institution: 'University of Guelph',
    numberOfVets: '5,100',
    annualSalary: 'CAD 85,000 - 100,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'Prince Edward Island',
    value: 'PE',
    institution: 'University of Prince Edward Island',
    numberOfVets: '200',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'Labrador Retriever',
  },
  {
    label: 'Quebec',
    value: 'QC',
    institution: 'Université de Montréal',
    numberOfVets: '2,200',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: 'German Shepherd',
  },
  {
    label: 'Saskatchewan',
    value: 'SK',
    institution: 'University of Saskatchewan',
    numberOfVets: '600',
    annualSalary: 'CAD 75,000 - 90,000',
    popularBreed: '',
  },
  {
    label: 'Yukon Territory',
    value: 'YT',
  },
]
